/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {TreesInnerValue} from './TreesInnerValue';
import {
  TreesInnerValueFromJSON,
  TreesInnerValueFromJSONTyped,
  TreesInnerValueToJSON
} from './TreesInnerValue';

/**
 *
 * @export
 * @interface TreeInfo
 */
export interface TreeInfo {
  /**
   *
   * @type {Array<{ [key: string]: TreesInnerValue; }>}
   * @memberof TreeInfo
   */
  trees: Array<{[key: string]: TreesInnerValue}>;
}

/**
 * Check if a given object implements the TreeInfo interface.
 */
export function instanceOfTreeInfo(value: object): value is TreeInfo {
  if (!('trees' in value) || value['trees'] === undefined) return false;
  return true;
}

export function TreeInfoFromJSON(json: any): TreeInfo {
  return TreeInfoFromJSONTyped(json, false);
}

export function TreeInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreeInfo {
  if (json == null) {
    return json;
  }
  return {
    trees: json['trees']
  };
}

export function TreeInfoToJSON(value?: TreeInfo | null): any {
  if (value == null) {
    return value;
  }
  return {
    trees: value['trees']
  };
}
